import { ServerMode } from '@zip/yi-core';
import { constants, urlsByEnvironment } from '../constants/constants';
import { FeatureFlagEnvironment } from '@zip/feature-flag-js';

const env = 'production';

export const environment = {
  production: true,
  environment: env,
  contentfulEnv: 'master',
  shopContentfulEnv: 'master',
  apiHost: 'https://zip.co/giftcards/api',
  appPrefix: '/giftcards',
  contentfulWS: {
    env: 'master',
    accessToken: 'DrqVti-VcDfYkRMA7FXiuuTHmoJ7qqaIIfv-xzrziDo',
    space: 's4pnkf0373wo',
  },
  contentfulAccessToken: '2567966bb492dffba3a916bfc6ed382b7409f0ddc0676abacf3300197643ff7d',
  checkoutmobileUrl: 'co.zip://deeplink/giftcards',
  giphyApiKey: 'P1kAaAWgyMA5CcusF0vSZvBie38DiwTX',
  s3Bucket: 'https://static.zipmoney.com.au',
  zipAnalytics: {
    appId: '86f12201-9421-4e8f-8887-c35d1d644ba1',
    endpoint: 'trx.zip.co',
    namespace: 'global-web',
  },
  zipIdp: {
    issuer: 'https://zip.co/login',
    clientId: 'zip-wallet-experiences-spa-1f9811e3-441e-4262-9bb9-a22dd3149c20',
  },
  zipAuth0: {
    issuer: 'https://auth.zip.co',
    clientId: 'Bu8I7jnmt3Bt0eLWtDDopDBYfbj9jyni',
    audience: 'https://api.zip.co',
  },
  zipYi: {
    env: ServerMode.P,
    appId: 'd5a095a5',
  },
  zipFeatureFlag: {
    env: FeatureFlagEnvironment.Prod,
    deploymentKey: 'client-WkVTQbnwRl1Tb3UJ3T93KU4iT2UBeuf0',
  },
  optimizely: {
    sdkKey: '21bqYkGvX7yCYh7Q67zAp',
    logLevel: null,
  },
  ...constants,
  ...urlsByEnvironment(env),
};
